import Preact, { Component } from 'preact'

class Textarea extends Component {
  constructor (props) {
    super()
    this.textareaElement = Preact.createRef()
    this.adjustHeight = this.adjustHeight.bind(this)
  }

  componentDidUpdate () {
    this.adjustHeight()
  }

  adjustHeight () {
    const el = this.textareaElement
    const outerHeight = parseInt(window.getComputedStyle(el).height, 10)
    const diff = outerHeight - el.clientHeight
    el.style.height = '48px'
    el.style.height = el.scrollHeight + diff + 'px'
  }

  render ({ class: customClass, placeholder, maxLength, onContentChange, onTextareaFocus, value, onInput, error }, state) {
    if (error) {
      customClass += ' error'
    }

    return (
      <textarea
        className={customClass}
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={(e) => { onContentChange(e.target.value) }}
        onClick={onTextareaFocus}
        value={value}
        onInput={(e) => this.adjustHeight(e)}
        ref={textarea => { this.textareaElement = textarea }}
      />
    )
  }
}

export default Textarea
